import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '@shared/redux/config-store-state.model';
import { PricingService } from './pricing.service';
import { firstValueFrom, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShipmentService {

  private maxamount = 0;
  private shippingcost = 0;

  private baseprice = 0;

  private user!: any;

  constructor(
    private store: Store<AppState>,
    private pricingService: PricingService
  ) {
    this.store.select(state => state.storeUser)
      .subscribe({
        next: userData => {
          this.user = userData?.user;
        }
      });
    this.store.select(state => state.storeConfig.maxamount)
      .subscribe({
        next: maxamount => {
          this.maxamount = maxamount;
        }
      });
    this.store.select(state => state.storeConfig.shippingcost)
      .subscribe({
        next: shippingcost => {
          this.shippingcost = shippingcost;
        }
      });
    this.store.select(state => state.storeConfig.baseprice)
      .subscribe({
        next: baseprice => {
          this.baseprice = baseprice;
        }
      });
  }

  getShipment(totalPhysical: number): Observable<number> {
    if (this.user && this.user.nationality) {
      // Envíos Argentina
      if (this.user.nationality == 'AR') {
        if (totalPhysical < this.maxamount) {
          // Costo de envío
          return of(this.pricingService.priceByCurrency(this.shippingcost));
        } else {
          // Sin costo de envío
          return of(this.pricingService.priceByCurrency(0));
        }
      } else {
        // Envíos internacionales
        return of(Math.round(this.pricingService.priceByCurrency(this.baseprice * this.pricingService.getDollarPrice())));
      }
    } else {
      // Sin costo de envío
      return of(this.pricingService.priceByCurrency(0));
    }
  }

  getShipmentPayPal(): Promise<number> {
    return firstValueFrom(
      of(
        Math.round(this.pricingService.priceByCurrencyPayPal(this.baseprice * this.pricingService.getDollarPrice()))
      )
    );
  }

  getShipmentAndTotal(totalPhysical: number): Observable<number> {
    if (this.user && this.user.nationality) {
      // Envíos Argentina
      if (this.user.nationality == 'AR') {
        if (totalPhysical < this.maxamount) {
          // Costo de envío
          return of(this.pricingService.priceByCurrency(this.shippingcost) + totalPhysical);
        } else {
          // Sin costo de envío
          return of(this.pricingService.priceByCurrency(0) + totalPhysical);
        }
      } else {
        // Envíos internacionales
        return of(Math.round(this.pricingService.priceByCurrency((this.baseprice * this.pricingService.getDollarPrice())) + totalPhysical));
      }
    } else {
      // Sin costo de envío
      return of(this.pricingService.priceByCurrency(0 + totalPhysical));
    }
  }

}
